import { tsValidateExists, tsValidateResult } from '@nu-art/ts-common';
import { smartDocParamType_Static, Validator_SmartDocStaticParam } from './static/index.js';
import { smartDocParamType_Dynamic, Validator_SmartDocDynamicParam } from './dynamic/index.js';
import { smartDocParamType_External, Validator_SmartDocExternalParam } from './external/index.js';
import { smartDocParamType_EHR, Validator_SmartDocEHRParam } from './ehr/index.js';
export const Validator_SmartDocParameter = (allowedParamTypes, allowedParamSubTypes) => [(param, parent) => {
        //If the log template parent isn't passed
        if (!parent)
            return 'Can not validate log template parameter without the log template';
        //If the param is unavailable
        if (!param)
            return tsValidateResult(param, tsValidateExists());
        //Assert Param type is allowed
        if (!allowedParamTypes.includes(param.type))
            return { type: `Param type not allowed: ${param.type}` };
        switch (param.type) {
            case smartDocParamType_Static: {
                //Assert allowed param subtype
                if (!allowedParamSubTypes[smartDocParamType_Static]?.includes(param.subType))
                    return { subType: `Static param subtype not allowed: ${param.subType}` };
                return Validator_SmartDocStaticParam(param, parent);
            }
            case smartDocParamType_Dynamic:
                return Validator_SmartDocDynamicParam(param, parent);
            case smartDocParamType_External:
                //Assert allowed param subtype
                if (!allowedParamSubTypes[smartDocParamType_External]?.includes(param.subType))
                    return { subType: `External param subtype not allowed: ${param.subType}` };
                return tsValidateResult(param, Validator_SmartDocExternalParam);
            case smartDocParamType_EHR:
                return tsValidateResult(param, Validator_SmartDocEHRParam);
            default: {
                // @ts-ignore
                return param.type ? `Unknown param type ${param.type}` : `Missing mandatory field: type`;
            }
        }
    }];
//# sourceMappingURL=validation.js.map